import React, { FC } from 'react';
import styled from './UpdatePriceWarningModal.module.css';
import Modal from '../../../../components/Modal/Modal';
import Button from '../../../../components/Button/Button';
import { Trans, useTranslation } from 'react-i18next';
import statusWarningIcon from '../../../../assets/images/statusWarningIcon.svg';

interface Props {
    onAccept: () => void;
    onClose: () => void;
}

const UpdatePriceWarningModal: FC<Props> = ({ onAccept, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal title={t('updateTotalPriceWarningTitle')} subtitle={t('updateTotalPriceWarningText')} className={styled.Modal}>
            <div className={styled.Content}>
                <img src={statusWarningIcon} alt="warning" className={styled.WarningIcon} />
                <div className={styled.Options}>
                    <Button variant="Primary" onClick={onClose}>
                        {t('buttonNo')}
                    </Button>
                    <Button variant="Outline" onClick={onAccept}>
                        {t('buttonYes')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default UpdatePriceWarningModal;
